import React, { createContext, useContext } from 'react';


const NavigationContext = createContext({});
const useNavigation = () => useContext(NavigationContext);

function withNavigationWatcher(Component) {
  const WrappedComponent = function (props) {
    return <Component {...props} />;
  }
  return <WrappedComponent />;
}

export {
  useNavigation,
  withNavigationWatcher
}
